import { render, staticRenderFns } from "./DetalleTicket.vue?vue&type=template&id=19aafbaa&scoped=true"
import script from "./DetalleTicket.vue?vue&type=script&lang=ts"
export * from "./DetalleTicket.vue?vue&type=script&lang=ts"
import style0 from "./DetalleTicket.vue?vue&type=style&index=0&id=19aafbaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aafbaa",
  null
  
)

export default component.exports